import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContestInterestedFreelancer } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor } from '@freelancer/ui/button';
import { HorizontalAlignment } from '@freelancer/ui/grid';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontSize, FontType } from '@freelancer/ui/text';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-contest-interested-freelancers-modal',
  template: `
    <ng-container
      *ngIf="
        (interestedFreelancers$ | async) as interestedFreelancers;
        else loading
      "
    >
      <fl-heading
        *ngIf="interestedFreelancers.length > 1; else singularTitle"
        i18n="Interested freelancers modal title"
        [headingType]="HeadingType.H2"
        [size]="HeadingSize.XSMALL"
      >
        Interested Freelancers
      </fl-heading>
      <ng-template #singularTitle>
        <fl-heading
          i18n="Interested freelancer modal title"
          [headingType]="HeadingType.H2"
          [size]="HeadingSize.XSMALL"
        >
          Interested Freelancer
        </fl-heading>
      </ng-template>
      <fl-bit [flMarginBottom]="Margin.SMALL">
        <fl-text
          *ngIf="interestedFreelancers.length > 1; else singularUser"
          i18n="interested freelancers description"
          [color]="FontColor.MID"
          [fontType]="FontType.SPAN"
          [size]="FontSize.SMALL"
        >
          These users are participating and may enter before your contest ends:
        </fl-text>
        <ng-template #singularUser>
          <fl-text
            i18n="interested freelancer description"
            [color]="FontColor.MID"
            [fontType]="FontType.SPAN"
            [size]="FontSize.SMALL"
          >
            This user is participating and may enter before your contest ends:
          </fl-text>
        </ng-template>
      </fl-bit>
      <fl-grid [flMarginBottom]="Margin.SMALL">
        <fl-col
          *ngFor="let freelancer of interestedFreelancers"
          [col]="6"
          [colDesktopSmall]="4"
          [flMarginBottom]="Margin.XXSMALL"
        >
          <fl-link [link]="freelancer.profileUrl">
            {{ freelancer.username }}
          </fl-link>
        </fl-col>
      </fl-grid>
      <fl-grid>
        <fl-col [col]="3" [pull]="'right'">
          <fl-button
            i18n="Ok button"
            [display]="'block'"
            [color]="ButtonColor.DEFAULT"
            [flMarginRight]="Margin.XSMALL"
            (click)="handleClick()"
          >
            OK
          </fl-button>
        </fl-col>
      </fl-grid>
    </ng-container>
    <ng-template #loading>
      <fl-grid
        [hAlign]="HorizontalAlignment.HORIZONTAL_CENTER"
        [flMarginBottom]="Margin.XSMALL"
      >
        <fl-col [col]="2" [colDesktopSmall]="1">
          <fl-spinner></fl-spinner>
        </fl-col>
      </fl-grid>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContestInterestedFreelancersModalComponent {
  ButtonColor = ButtonColor;
  FontColor = FontColor;
  FontSize = FontSize;
  FontType = FontType;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;
  HorizontalAlignment = HorizontalAlignment;
  Margin = Margin;

  @Input() interestedFreelancers$: Rx.Observable<
    ReadonlyArray<ContestInterestedFreelancer>
  >;

  constructor(
    private modalRef: ModalRef<ContestInterestedFreelancersModalComponent>,
  ) {}

  handleClick() {
    this.modalRef.close();
  }
}
